import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/messaging';
import 'firebase/firestore';
import 'firebase/auth';
import moment from 'moment';
import { getFirebaseApp } from './firebaseApp';

var firebaseConfig = {}
const url = window.location.href;

if( url.includes("https://prioritypet-aliados.web.app/") || url.includes("localhost") ){
  
  firebaseConfig = {
    apiKey: "AIzaSyBktfTPjI4mXeW9aHf_t1q5AiRJFhWLVYQ",
    authDomain: "priority-pet.firebaseapp.com",
    databaseURL: "https://priority-pet.firebaseio.com",
    projectId: "priority-pet",
    storageBucket: "priority-pet.appspot.com",
    messagingSenderId: "869082577685",
    appId: "1:869082577685:web:fe72bd4dec8cb25ae6c71c",
    measurementId: "G-Y43D2W1BQY"
  };
  console.log('Estamos en desarrollo')
  
}else if( url.includes("https://prioritypet-aliados-qa.web.app/") ){
  firebaseConfig = {
    apiKey: "AIzaSyDh4Vku78GTJhADuWyfNNKY_Gx-dzDkO3c",
    authDomain: "priority-pet-quality.firebaseapp.com",
    projectId: "priority-pet-quality",
    storageBucket: "priority-pet-quality.appspot.com",
    messagingSenderId: "905988100721",
    appId: "1:905988100721:web:a96b744655e67edcb2c1d0",
    measurementId: "G-SPZ88TE2VR"
  };
  console.log('Estamos en calidad')
}else if( url.includes("prioritypetaliados") ){
  firebaseConfig = {
    apiKey: "AIzaSyB4WLXTWQPpXwYKGNwW6ddkiQvbwG1ZLQQ",
    authDomain: "priority-pet-prod.firebaseapp.com",
    projectId: "priority-pet-prod",
    storageBucket: "priority-pet-prod.appspot.com",
    messagingSenderId: "263820990167",
    appId: "1:263820990167:web:260652203b4655bb604292",
    measurementId: "G-KE9LYV2PPH"
  };
  console.log('Estamos en producción')
}


class Firebase {
  
  constructor(){
      firebase.initializeApp(firebaseConfig);
      this.auth = firebase.auth();
      this.db = firebase.firestore();
      this.storage = firebase.storage();
      this.messaging  = firebase.messaging();
      this.serverKey = "BIYK8Takt6wVnGYDZxLx1fe5_NwEQQTNR8jtnfusdN4oxlMC9zRramEGs-MBLFLVWeGB_MBqkarnagZudYdnfRU"
      this.projectId = firebaseConfig.projectId
    }

    //Inicar sesión
    async login(email, password, tipos){      
      if(tipos.includes(email)){
        return this.auth.signInWithEmailAndPassword(email, password)
      }
    }
    
    //Registro
    async register(email, password){
        await this.auth.createUserWithEmailAndPassword(email, password)
    }

    addUser(email, userInfo, url) {
		  if(!this.auth.currentUser) {
		  	return alert('Not authorized')
		  }
        
      let aliados = []
      this.db.collection('Aliados').get().then(data=>{  
        data.forEach(tipo=>{
          aliados.push(tipo.id)
        })
      })
		  return this.db.collection("Aliados").doc(this.auth.currentUser.uid).set({
        aliadoId: this.auth.currentUser.uid,
        nombre: userInfo.nombre,
        isApproved: false,
        aliadoCodigo: userInfo.codigoArea + userInfo.cantidadAliados,
        nombreComercial: userInfo.nombreComercial ?? userInfo.nombre,
        tipoEmpresa: userInfo.tipoEmpresa, 
        bienvenida: false,
        countRatings: 0,
        totalRatings: 0,
        tipoAliado: userInfo.tipoAliado, 
        tipoMercado: userInfo.tipoMercado, 
        pais: userInfo.pais,
        telefono: userInfo.telefono,
        identificacion: userInfo.identificacion,
        direccion: userInfo.direccion,
        role: userInfo.role,
        avatar: url,
        email: email,
        createdOn: moment().toDate()
      }).then((val)=>{
        var localidadId = this.db.collection("Localidades").doc().id
        this.db.collection("Localidades").doc(localidadId).set({
          aliadoId: this.auth.currentUser.uid,
          serviciosContiene: false,
          localidadId: localidadId,
          nombreLocalidad: "Localidad Principal",
          locacionImg: url,
          ciudad: userInfo.direccion,
          pais: userInfo.pais,
          lc: "Localidad Principal",
          direccionDetallada: userInfo.direccion,
          direccionLocalidad: userInfo.direccion,
          telefono: userInfo.telefono,
          otroTelefono: userInfo.telefono,
          createdOn: moment().toDate(),
        })

        let typesOfPetFriendly = [
          "Restaurante o Café Pet Friendly",
          "Otros lugares Pet Friendly"
        ]

        if(typesOfPetFriendly.includes(userInfo.tipoAliado)){

          var placeId = this.db.collection("Places").doc().id

          let place = {
            createdOn: moment().toDate(),
            description: userInfo.direccion,
            geolocation: "",
            media: [{
              index: 1,
              url: url,
              type: "photo"
            }],
            name: userInfo.nombreComercial,
            placeId: placeId,
            subjectId: this.auth.currentUser.uid,
            subjectType: "aliado",
            type: "Park"
          }
  
          this.db.collection("Places").doc(placeId).set(place)
        }

        this.db.collection("Aliados").doc(this.auth.currentUser.uid).collection("Petpoints")
        .doc(this.auth.currentUser.uid).set({
          aliadoId: this.auth.currentUser.uid,
          ppAcumulados: 500,
          ppCanjeados: 0,
          createdOn: moment().toDate(),
        })

        this.db.collection("Dueños").doc(this.auth.currentUser.uid).set({
          uid: this.auth.currentUser.uid,
          email: email,
          user: userInfo.nombre,
          url: url,
          bienvenida: true,
          registroCompleto: false,
        })

      })
	}

    // Crear instancia local en la función para crear el usuario 
    async createRoleUser(email, password, userInfo, url){

      let authInstance = getFirebaseApp('auth-worker');
      let authInstanceWorker = firebase.auth(authInstance);
      authInstanceWorker.setPersistence(firebase.auth.Auth.Persistence.NONE);
  
      try {
        const userData = await authInstanceWorker.createUserWithEmailAndPassword(email, password);
        await this.db.collection("Aliados").doc(userData.user.uid).set({
          aliadoId: userData.user.uid,
          nombre: userInfo.nombre,
          isApproved: false,
          aliadoAdminId: userInfo.aliadoId,
          aliadoCodigo: userInfo.codigoArea + userInfo.aliadosLength,
          nombreComercial: userInfo.nombreComercial,
          tipoEmpresa: userInfo.tipoEmpresa,
          tipoAliado: userInfo.tipoAliado,
          pais: userInfo.pais,
          telefono: userInfo.telefono,
          identificacion: userInfo.identificacion,
          direccion: userInfo.direccion,
          avatar: userInfo.avatar,
          role: userInfo.role,
          email: email,
        })
        await this.db.collection("Aliados").doc(userInfo.aliadoId).collection("Usuarios").doc(userData.user.uid).set({
          aliadoId: userData.user.uid,
        })
        await this.db.collection("Aliados").doc(userData.user.uid).collection("Petpoints")
        .doc(userData.user.uid).set({
          aliadoId: userData.user.uid,
          ppAcumulados: 500,
          ppCanjeados: 0,
          createdOn: moment().toDate(),
        })
        return userData
      } catch (error) {
        return error;
      }
    }
    
    async createClient(aliadoId, clientes, email, password, userInfo, url){

      let authInstance = getFirebaseApp('auth-worker');
      let authInstanceWorker = firebase.auth(authInstance);
      authInstanceWorker.setPersistence(firebase.auth.Auth.Persistence.NONE);
  
      
      try {
        const uid = await (await authInstanceWorker.createUserWithEmailAndPassword(email, password)).user.uid;
        this.db.collection("Dueños").doc(uid).set({
          uid: uid,
          email: email,
          user: userInfo,
          url: url,
          bienvenida: true,
          walkin: true,
          // token: token,
          registroCompleto: false,
        }).then((val)=>{

          // let clientesParam = [uid]
          // let clientesUpdated = clientes === undefined ? clientesParam : clientes.push(uid)
          
          // this.db.collection("Aliados").doc(aliadoId).update({
          //   clientes: clientesUpdated
          // })
          
          this.db.collection("Dueños").doc(uid).collection("Petpoints").doc(uid).set({
            uid: uid,
            ppAcumulados: 0,
            ppCanjeados: 0,
            ppGenerados: 0,
          })

        })
        return uid
      } catch (error) {
        return alert(error);
      }
    }

  //Salir de la sesión
  logout(){
      return this.auth.signOut()
  }

  isInitialized() {
		return new Promise(resolve => {
			this.auth.onAuthStateChanged(resolve)
		})
	}
    
  isLogged() {
	    return this.auth.currentUser;
	}

  async getCountryInfo(pais){
    let data = await this.db.collection("Ciudades").doc(pais).get()
    return data
  }
  
  async getRoleInfo(rol){
    let dataDefault = {
      activeOrders: true,
      activeClaims: true,
      activeClients: true,
      activeMessage: true,
      activeRefereds: true,
      activeServices: true,
      activePromotions: true,
      activeProducts: true,
    }
    let data = await this.db.collection("Roles").doc(rol).get()
    return rol === "Administrador" ? dataDefault : data.data()
  }

  async getToken(setTokenFound){
    try {
      const currentToken = await this.messaging.getToken();
      if (currentToken) {
        setTokenFound(true);
      } else {
        setTokenFound(false);
        // shows on the UI that permission is required 
      }
    } catch (err) {
      console.log('Error: ' + err);
    }
  }
  
  onMessageListener = () =>
    new Promise((resolve) => {
    this.messaging.onMessage((payload) => {
      resolve(payload);
    });
  });

  async getCurrentUser() {
		const user = await this.db.doc(`Aliados/${this.auth.currentUser.uid}`).get()        
		return user.data()
	}

}

export default new Firebase()
